import { EditorState, PluginKey } from 'prosemirror-state'
import { State } from './Types'

export const DATA_TYPE_ATTR = 'tracked-change'

export const trackChangesKey = new PluginKey<State>('trackChanges')

export function getTrackChangesState(editorState: EditorState) {
  const pluginState = trackChangesKey.getState(editorState)
  if (!pluginState) {
    throw new Error('Track changes plugin is not registered on the current editor state.')
  }
  return pluginState
}

/**
 * Safe version of getTrackChangesState that returns undefined instead of throwing
 * when the Track Changes plugin is not registered. Use this in components that
 * may render without the plugin being present.
 */
export function tryGetTrackChangesState(editorState: EditorState): State | undefined {
  return trackChangesKey.getState(editorState) ?? undefined
}
